let currentActionFB = "login";
let fbSDKLoaded = false;

window.fbAsyncInit = function () {
    FB.init({
        appId: "603927012591003", 
        autoLogAppEvents: true,
        cookie: true,
        xfbml: false,
        version: "v22.0",
    });

    fbSDKLoaded = true;
};

(function (d, s, id) {
    if (d.getElementById(id)) {
        return;
    }
    
    let js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/es_LA/sdk.js";
    js.onload = () => {
    };

    let fjs = d.getElementsByTagName(s)[0];
    fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

const observer = new MutationObserver(() => {
    const loginButton = document.getElementById("facebookLoginButton");
    //const signupButton = document.getElementById("facebookCreateAccountButton");

    if (loginButton) {
      observer.disconnect();

      setupFacebookButton(loginButton, "login");
      //setupFacebookButton(signupButton, "signup");
    }
});

observer.observe(document.body, { childList: true, subtree: true });

function setupFacebookButton(buttonElement, actionType) {

    buttonElement.addEventListener("click", function () {
        currentActionFB = actionType; // Guardamos la acción antes del login

        if (!fbSDKLoaded) {
        console.warn("Facebook SDK aún no está listo, esperando...");
        return;
        }

        FB.login(
        function (response) {
            if (response.authResponse) {
            checkLoginState();
            } else {
            }
        },
        { scope: "public_profile,email" }
        );
    });
}

function checkLoginState() {
    FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
        obtenerDatosUsuario(response.authResponse.accessToken);
        } else {            
        }
    });
}

function obtenerDatosUsuario(accessToken) {
  FB.api('/me', { fields: 'id,first_name,last_name,email,location' }, function(response) {
    if (response && !response.error) {
      /*
      if (currentActionFB === "signup") {
        const userData = {
          userId: response.id,
          firstName: response.first_name,
          lastName: response.last_name,
          email: response.email,
          location: response.location ? response.location.name : null,
          accessToken: accessToken
        };
        sendToBackendFB(userData, "POST");
      } else {
        sendToBackendFB({ email: response.email }, "GET");
      }
      */
      sendToBackendFB({ email: response.email, return_to: "https://www.youaresavvy.com/pages/subscription-checkout" }, "GET");
    } else {
      console.error("Error al obtener los datos del usuario:", response.error);
    }
  });
}

function fillInformationFB(info){
  console.log(info);

  const firstName = document.getElementById('firstname');
  const lastName = document.getElementById('lastname');
  const email = document.getElementById('email');
  const phone = document.getElementById('phone');

  const firstNameEnvio = document.getElementById('firstname-envio');
  const lastNameEnvio = document.getElementById('lastname-envio');
  const emailEnvio = document.getElementById('email-envio');
  const phoneEnvio = document.getElementById('phone-envio');

  firstName.value = info.first_name;
  lastName.value = info.last_name;
  email.value = info.email;
  phone.value = info.phone;

  const checkboxPersonal = document.getElementById('personal-data');

  if(checkboxPersonal.checked){
      firstNameEnvio.value = firstName.value;
      lastNameEnvio.value = lastName.value;
      emailEnvio.value = email.value;
      obtenerDireccionesDeUsuarioF();
      phoneEnvio.value = phone.value;
  }

  document.getElementById('iniciar-sesion-button').style.display = 'none';
}

function shopifyRedirectCheckout(token) {
  if (token) {
      window.location.href = `https://savvy-colombia.myshopify.com/account/login/multipass/${token}`;
  } else {
    console.error("No se recibió un token válido.");
  }
}

function sendToBackendFB(data, method) {
    let url = "https://fhpssxfwatz2fnjtnkarzidmym0gzrio.lambda-url.us-east-2.on.aws/";
    if (method === "GET") {
        url += `?email=${encodeURIComponent(data.email)}&return_to=${data.return_to}`;
    }

    fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: method === "POST" ? JSON.stringify(data) : undefined
    })
    .then(response => {
      if (!response.ok) {
        //const createAccountDiv = document.querySelector(`[id^="create_"]`);
        const loginAccountDiv = document.querySelector(`[id^="login_"]`);
  
        switch(response.status){
          case 500:
            if(loginAccountDiv){
              const originalContent = loginAccountDiv.innerHTML;
              
              const buttonElement = document.querySelector(".t4s_btn_submmit");
              let buttonClasses = "";
      
              if (buttonElement) {
                buttonClasses = buttonElement.className;
              } else {
                buttonClasses = "t4s_btn_submmit t4s-btn t4s-btn-base t4s-btn-default-width";
              }
      
              loginAccountDiv.innerHTML=`
                <div class="container mt-5">
                  <div class="card" style="width: 18rem; background-color: #BFD4AC; width: 100%; border: 2px solid #85A765; border-radius: 4px">
                    <div class="d-flex" style="padding: 15px 0px 15px 15px; display:flex; flex-direction: column;">
                      
                      <div id="welcome-text-container" style="display:flex; gap: 5px;">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.0089 7.74023H15.7526C15.4794 7.74023 15.2196 7.87148 15.0588 8.09648L10.8481 13.9358L8.94099 11.2893C8.78028 11.067 8.52314 10.9331 8.24724 10.9331H6.99099C6.81688 10.9331 6.7151 11.1313 6.81688 11.2733L10.1544 15.9018C10.2332 16.0119 10.3372 16.1016 10.4576 16.1634C10.578 16.2253 10.7114 16.2575 10.8468 16.2575C10.9822 16.2575 11.1156 16.2253 11.236 16.1634C11.3564 16.1016 11.4604 16.0119 11.5392 15.9018L17.1803 8.08041C17.2847 7.93845 17.183 7.74023 17.0089 7.74023Z" fill="black"/>
                          <path d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z" fill="black"/>
                        </svg>
                        <p style="font-weight: bold; color: black; margin-bottom: 8px;">No encontramos tu cuenta</p>
                      </div>
      
                      <div id="account-creation-success-text-container" style="display:flex; flex-direction: column; margin-left:29px;">
                        <p style="color: black;">Te invitamos a registrarte haciendo click en el boton de abajo</p>                  
                      </div>
                      
                    </div>
                  </div>
      
                  <div class="t4s_field t4s_mb_20">
                    <a id="goToRegister" class="${buttonClasses}" data-login-sidebar="create" href="https://shopify.com/78109081634/account?locale=en&amp;region_country=CO" style="margin-top: 24px;text-decoration: none;color: white;">
                        Registrarse
                    </a>
                  </div>
                </div>`;
      
              document.getElementById("goToRegister").addEventListener("click", function() {
                setTimeout(() => {
                  loginAccountDiv.innerHTML = originalContent;
                }, 500);
              });
            }
            break;
  
          default:
            if(loginAccountDiv){
              const originalContent = loginAccountDiv.innerHTML;
                
              const buttonElement = document.querySelector(".t4s_btn_submmit");
              let buttonClasses = "";
  
              if (buttonElement) {
                buttonClasses = buttonElement.className;
              } else {
                buttonClasses = "t4s_btn_submmit t4s-btn t4s-btn-base t4s-btn-default-width";
              }
  
              loginAccountDiv.innerHTML=`
                <div class="container mt-5">
                  <div class="card" style="width: 18rem; background-color: #BFD4AC; width: 100%; border: 2px solid #85A765; border-radius: 4px">
                    <div class="d-flex" style="padding: 15px 0px 15px 15px; display:flex; flex-direction: column;">
                        
                      <div id="welcome-text-container" style="display:flex; gap: 5px;">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.0089 7.74023H15.7526C15.4794 7.74023 15.2196 7.87148 15.0588 8.09648L10.8481 13.9358L8.94099 11.2893C8.78028 11.067 8.52314 10.9331 8.24724 10.9331H6.99099C6.81688 10.9331 6.7151 11.1313 6.81688 11.2733L10.1544 15.9018C10.2332 16.0119 10.3372 16.1016 10.4576 16.1634C10.578 16.2253 10.7114 16.2575 10.8468 16.2575C10.9822 16.2575 11.1156 16.2253 11.236 16.1634C11.3564 16.1016 11.4604 16.0119 11.5392 15.9018L17.1803 8.08041C17.2847 7.93845 17.183 7.74023 17.0089 7.74023Z" fill="black"/>
                          <path d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z" fill="black"/>
                        </svg>
                        <p style="font-weight: bold; color: black; margin-bottom: 8px;">Encontramos un error</p>
                      </div>
  
                      <div id="account-creation-success-text-container" style="display:flex; flex-direction: column; margin-left:29px;">
                        <p style="color: black;">Informacion del error: ${response.text}</p>
                        <br>
                        <p style="color: black;">Puedes volver a intentar el registro haciendo click en el botón de abajo</p>
                      </div>
                        
                    </div>
                  </div>
  
                  <div class="t4s_field t4s_mb_20">
                    <a id="backToRegister" class="${buttonClasses}" data-login-sidebar="create" href="https://shopify.com/78109081634/account?locale=en&amp;region_country=CO" style="margin-top: 24px;text-decoration: none;color: white;">
                      Regresar
                    </a>
                  </div>
                </div>`;
  
              document.getElementById("backToRegister").addEventListener("click", function() {
                setTimeout(() => {
                  loginAccountDiv.innerHTML = originalContent;
                }, 500);
              });
            }
            break;
        }
      }

      //const createAccountDiv = document.querySelector(`[id^="create_"]`);
      const loginAccountDiv = document.querySelector(`[id^="login_"]`);

      switch(response.status){
        case 200: //Usuario loggeado
          if(loginAccountDiv){
            const originalContent = loginAccountDiv.innerHTML;
            
            const buttonElement = document.querySelector(".t4s_btn_submmit");
            let buttonClasses = "";

            if (buttonElement) {
              buttonClasses = buttonElement.className;
            } else {
              buttonClasses = "t4s_btn_submmit t4s-btn t4s-btn-base t4s-btn-default-width";
            }

            loginAccountDiv.innerHTML=`
              <div class="container mt-5">
                <div class="card" style="width: 18rem; background-color: #BFD4AC; width: 100%; border: 2px solid #85A765; border-radius: 4px">
                  <div class="d-flex" style="padding: 15px 0px 15px 15px; display:flex; flex-direction: column;">
                    
                    <div id="welcome-text-container" style="display:flex; gap: 5px;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.0089 7.74023H15.7526C15.4794 7.74023 15.2196 7.87148 15.0588 8.09648L10.8481 13.9358L8.94099 11.2893C8.78028 11.067 8.52314 10.9331 8.24724 10.9331H6.99099C6.81688 10.9331 6.7151 11.1313 6.81688 11.2733L10.1544 15.9018C10.2332 16.0119 10.3372 16.1016 10.4576 16.1634C10.578 16.2253 10.7114 16.2575 10.8468 16.2575C10.9822 16.2575 11.1156 16.2253 11.236 16.1634C11.3564 16.1016 11.4604 16.0119 11.5392 15.9018L17.1803 8.08041C17.2847 7.93845 17.183 7.74023 17.0089 7.74023Z" fill="black"/>
                        <path d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z" fill="black"/>
                      </svg>
                      <p style="font-weight: bold; color: black; margin-bottom: 8px;">¡Bienvenido ${data.firstName}!</p>
                    </div>

                    <div id="account-creation-success-text-container" style="display:flex; flex-direction: column; margin-left:29px;">
                      <p style="color: black;">Iniciaste sesión correctamente! Pronto te redirecionaremos a la página de tu cuenta</p>                  
                    </div>
                    
                  </div>
                </div>

                <div class="t4s_field t4s_mb_20">
                  <a id="backToLogin" class="${buttonClasses}" data-login-sidebar="login" href="https://shopify.com/78109081634/account?locale=en&amp;region_country=CO" style="margin-top: 24px;text-decoration: none;color: white;">
                    Iniciar sesión
                  </a>
                </div>
              </div>`;

            setTimeout(()=> {
              document.querySelector('.overlay-login-sidebar-checkout').style.display = 'none';
              shopifyRedirectCheckout(data.multipass);
            }, 500);
          }
          break;
      }

      let responseJSON = response.json()
      return responseJSON;
    })
    .then(data => {
        if (data) {
            if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 422) {
              shopifyRedirectCheckout(data.multipass);
            } else {
              alert("User not found");
            }
          }
    })
    .catch(error => console.error("Error al enviar datos a Shopify:", error));
}

async function obtenerDireccionesDeUsuarioF(){
  const selectDirecciones = document.getElementById('direcciones-usuario-envio');

  const checkboxDatosPersonales = document.getElementById('personal-data');

  if(checkboxDatosPersonales.checked){
      if(email.value != ""){
          try{
              const response = await fetch("https://n6bvw5g5mcbxerodytgfde7n7y0grxdg.lambda-url.us-east-2.on.aws/get_usuario_y_direcciones", {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ action: "obtener_direcciones", email: email.value })
              })
          
              if (!response.ok) {
                  const errorText = await response.text();
                  throw new Error(`Error en response: ${response.status} ${response.statusText} - ${errorText}`);
              }

              const responseData = await response.json();

              while (selectDirecciones.options.length > 1) {
                  selectDirecciones.remove(1);
              }

              if (responseData.direcciones && Array.isArray(responseData.direcciones)){

                  responseData.direcciones.forEach((direccion, index)=> {
                      let textoOpcion = `${direccion.direccion || ''}`;

                      if (direccion.codigo_postal) {
                          textoOpcion += ` (Código Postal: ${direccion.codigo_postal})`;
                      }

                      const valorOpcion = index;

                      const opcion = new Option(textoOpcion, valorOpcion);

                      selectDirecciones.add(opcion);

                  });

                  selectDirecciones.dataset.direccionesData = JSON.stringify(responseData.direcciones);

              }else{
                  console.error("No se recibieron direcciones válidas en la respuesta.");
              }

          }catch (error){
              console.error("Error durante la obtención o procesamiento de direcciones:", error);
              while (selectDirecciones.options.length > 1) {
                  selectDirecciones.remove(1);
              }
          }

      }else{
          console.error("El email del usuario no puede estar vacío");
      }
  }else{
      console.log("Checkbox desmarcado, limpiando direcciones...");
      while (selectDirecciones.options.length > 1) {
          selectDirecciones.remove(1);
      }
      // Elimina los datos guardados si se añadieron
      if (selectDirecciones.dataset.direccionesData) {
          delete selectDirecciones.dataset.direccionesData;
      }
  }
}